import { Action, configureStore } from "@reduxjs/toolkit";
import rootReducer from "./rootReducer";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "persist-key",
  storage,
};
const CLEAR_STORAGE = "CLEAR_STORAGE";

export const clearStorage = () => ({
  type: CLEAR_STORAGE,
});

const rootReducerWithClear = (state: any, action: Action) => {
  if (action.type === CLEAR_STORAGE) {
    storage.removeItem("persist:persist-key");
    state = undefined;
  }
  return persistedReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = configureStore({
  reducer: rootReducerWithClear,
});

export const persistor = persistStore(store);
export default store;
